import { isBrowser } from '../../../helpers/environment';

export const shareData = (url: string) => {
  return {
    title: 'Haven',
    text: 'Share this page',
    url,
  };
};

export const canShare =
  isBrowser() &&
  navigator.canShare !== undefined &&
  navigator.canShare({ url: window.location.href });
